import { createAction, props } from '@ngrx/store';
import { categoryFavoriteEntity } from './category-favorite.models';

export const loadCategoryFavorites = createAction(
  '[Category Favorites] Load Category Favorites',
  props<{ language: string }>()
);

export const loadCategoryFavoritesSuccess = createAction(
  '[Category Favorites] Load Category Favorites Success',
  props<{ categoryFavorites: categoryFavoriteEntity }>()
);

export const loadCategoryFavoritesFailure = createAction(
  '[Category Favorites] Load Category Favorites Failure',
  props<{ error: any }>()
);

export const setCategoryFavorite = createAction('[Category Favorites] Set Category Favorite', props<{ id: string }>());

export const setCategoryFavoriteSuccess = createAction(
  '[Category Favorites] Set Category Favorite Success',
  props<{ response: any }>()
);

export const setCategoryFavoriteFailure = createAction(
  '[Category Favorites] Set Category Favorite Failure',
  props<{ error: any }>()
);

export const deleteCategoryFavorite = createAction(
  '[Category Favorites] Delete Category Favorite',
  props<{ id: string }>()
);

export const deleteCategoryFavoriteSuccess = createAction(
  '[Category Favorites] Delete Category Favorite Success',
  props<{ response: any }>()
);

export const deleteCategoryFavoriteFailure = createAction(
  '[Category Favorites] Delete Category Favorite Failure',
  props<{ error: any }>()
);
